/**
 * Módulo que gerencia o estado das mensagens exibidas na aplicacao
 * @state Estados que devem ser controlados
 * @mutations Funções que tem permissão para alterar o state
 * @actions Executar operações asincronas e chamar mutations 
 * @getters Retorna o estado além da possibilidade de retornar a 
 * mesma lógica do computed (Gera valores com base em valores originais)
 */

const state = {
    /**
     * Estado para armazenas o geojson
     */
    geoJsonFzda: {},
    geoJsonTlho: [],
    geoJsonPtio: [],

    /**
     * Geojson Temporário para caso cancele importação de poligono
     */
    tempGeoJson: [],

    /**
     * Estados que identifica se Fazenda, Talhão ou Plantio possuem shape cadastrado no 
     * banco de dados da aplicacao
     */
    fzdaHasFileInDB: false,
    tlhoHasFileInDB: false,
    ptioHasFileInDB: false,
}

const mutations = {
    /**
     * Seta o geojson de Fazenda, Talhão e Plantio
     */
    setGeoJsonFzda: (state : any, value : any) => state.geoJsonFzda = value,
    setGeoJsonTlho: (state : any, value : any) => state.geoJsonTlho = value,
    setGeoJsonPtio: (state : any, value : any) => state.geoJsonPtio = value,

    /**
     * Seta o geojson temporário
     */
    setTempGeoJson: (state : any, value : any) => state.tempGeoJson = value,

    /**
     * Seta se possuem ou não shape salvo no banco de dados da aplicação
     */
    setFzdaHasFileInDB: (state : any, value : any) => state.fzdaHasFileInDB = value,
    setTlhoHasFileInDB: (state : any, value : any) => state.tlhoHasFileInDB = value,
    setPtioHasFileInDB: (state : any, value : any) => state.ptioHasFileInDB = value,

    /**
     * Reseta o estado para o valor inicial
     */
    resetImportShapeState: (state : any) => {
        state.geoJsonFzda = {},
            state.geoJsonTlho = [],
            state.geoJsonPtio = [],
            state.tempGeoJson = [],
            state.fzdaHasFileInDB = false,
            state.tlhoHasFileInDB = false,
            state.ptioHasFileInDB = false
    }
}

const actions = {}

const getters = {
    /**
     * Método para recuperar o geojson atual que está sendo importado
     */
    getGeoJsonFzda: (state : any) => state.geoJsonFzda,
    getGeoJsonTlho: (state  :any) => state.geoJsonTlho,
    getGeoJsonPtio: (state : any) => state.geoJsonPtio,

    /**
     * Retorna o geojson temporário
     */
    getTempGeojson: (state  :any) => state.tempGeoJson,

    /**
     * Métodos para recuperar se Fazenda Talhão ou Plantio possuem shape cadastrado
     * no banco de dados da aplicacao
     */
    getFzdaHasFileInDB: (state  :any) => state.fzdaHasFileInDB,
    getTlhoHasFileInDB: (state  :any) => state.tlhoHasFileInDB,
    getPtioHasFileInDB: (state  :any) => state.ptioHasFileInDB,
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}